(function () {
  'use strict';

  try {
    function getCustomerCountry() {
      try {
        var testCountry = window.sessionStorage ? window.sessionStorage.getItem('test_country') : null;
        if (testCountry) return testCountry.trim().toUpperCase();
      } catch (_e) {}

      try {
        if (window.ShopifyCustomerCountry && typeof window.ShopifyCustomerCountry === 'string') {
          return window.ShopifyCustomerCountry.trim().toUpperCase();
        }
        if (window.Shopify && window.Shopify.country && typeof window.Shopify.country === 'string') {
          return window.Shopify.country.trim().toUpperCase();
        }
      } catch (_e) {}

      return '';
    }

    var country = getCustomerCountry();
    var isUSA = country === 'US';

    if (isUSA) return;

    try {
      if (document && document.head && !document.getElementById('salepify-non-usa-milestone-hide')) {
        var style = document.createElement('style');
        style.id = 'salepify-non-usa-milestone-hide';
        style.textContent = [
          '[class*="tl__cart-goal__free-gift-container"] .tl-cart-goal-apply-free-shipping-btn__cart-drawer,',
          '[class*="tl__cart-goal__free-gift-container"] .prow:has(.tl-cart-goal-apply-free-shipping-btn__cart-drawer) {',
          '  display: none !important;',
          '}'
        ].join('\n');
        document.head.appendChild(style);
      }
    } catch (_e) {}

    function cleanAndRealignMilestones() {
      try {
        var allCheckpoints = document.querySelectorAll('.tl__cart-goal__goal-check-point__drawer');

        if (allCheckpoints && allCheckpoints.length > 2) {
          allCheckpoints.forEach(function (cp) {
            try {
              var title = cp.querySelector('.tl__cart-goal__goal-check-point-title');
              if (title && title.textContent && (title.textContent.includes('USA') || title.textContent.includes('Shipping'))) {
                cp.remove();
              }
            } catch (_e) {}
          });

          var remaining = document.querySelectorAll('.tl__cart-goal__goal-check-point__drawer');
          if (remaining && remaining.length > 0) {
            var total = remaining.length;
            remaining.forEach(function (cp, index) {
              try {
                var newMargin = ((index + 1) / total) * 100;
                cp.style.marginLeft = newMargin + '%';
              } catch (_e) {}
            });
          }
        }

        var shippingBtns = document.querySelectorAll('.tl-cart-goal-apply-free-shipping-btn__cart-drawer');
        if (shippingBtns && shippingBtns.length > 0) {
          shippingBtns.forEach(function (btn) {
            try {
              var row = btn.closest('.prow') || btn.parentElement;
              if (row) row.remove();
              else btn.remove();
            } catch (_e) {}
          });
        }
      } catch (domErr) {
        console.warn('[Salepify Custom] Clean DOM error:', domErr);
      }
    }

    try {
      var observer = new MutationObserver(function () {
        cleanAndRealignMilestones();
      });

      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          if (document.body) {
            observer.observe(document.body, { childList: true, subtree: true });
          }
        });
      }
    } catch (_e) {}

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cleanAndRealignMilestones);
    } else {
      cleanAndRealignMilestones();
    }

  } catch (globalErr) {
    console.warn('[Salepify Custom] Script execution bypassed safely:', globalErr);
  }
})();

// custom PG cho US
(function () {
  'use strict';

  try {
    function getCustomerCountry() {
      try {
        var testCountry = window.sessionStorage ? window.sessionStorage.getItem('test_country') : null;
        if (testCountry) return testCountry.trim().toUpperCase();
      } catch (_e) {}

      try {
        if (window.ShopifyCustomerCountry && typeof window.ShopifyCustomerCountry === 'string') {
          return window.ShopifyCustomerCountry.trim().toUpperCase();
        }
        if (window.Shopify && window.Shopify.country && typeof window.Shopify.country === 'string') {
          return window.Shopify.country.trim().toUpperCase();
        }
      } catch (_e) {}

      return '';
    }

    var country = getCustomerCountry();
    var isUSA = country === 'US';

    if (isUSA) return;

    try {
      if (document && document.head && !document.getElementById('salepify-non-usa-progressbar-hide')) {
        var style = document.createElement('style');
        style.id = 'salepify-non-usa-progressbar-hide';
        style.textContent = [
          '[class*="tl__cart-goal"] {',
          '  display: none !important;',
          '}'
        ].join('\n');
        document.head.appendChild(style);
      }
    } catch (_e) {}

  } catch (globalErr) {
    console.warn('[Salepify Custom] Script execution bypassed safely:', globalErr);
  }
})();

// custom button free shipping auto add
(function () {
  'use strict';

  try {
    var SESSION_KEY = 'salepify_free_shipping_auto_applied';
    var hasAppliedThisSession = (function () {
      try {
        return window.sessionStorage.getItem(SESSION_KEY) === '1';
      } catch (_e) {
        return false;
      }
    })();

    var isProcessing = false; // chặn gọi chồng khi đang xử lý
    var debounceTimer = null;

    function markAppliedPermanently() {
      hasAppliedThisSession = true;
      try {
        window.sessionStorage.setItem(SESSION_KEY, '1');
      } catch (_e) {}
    }

    function greyOutButton(btn) {
      try {
        btn.style.pointerEvents = 'none';
        btn.style.setProperty('opacity', '1', 'important');
        btn.style.setProperty('background', 'rgba(255, 204, 204, 1.00)', 'important');
        btn.style.filter = 'none';
        btn.style.cursor = 'default';
        btn.setAttribute('aria-disabled', 'true');
        btn.onclick = null;
        btn.removeAttribute('onclick');
      } catch (_e) {}
    }

    function autoApplyFreeShipping() {
      // Nếu đã apply thành công 1 lần trong session này -> chỉ còn việc grey out, KHÔNG click/gọi hàm nữa
      var btn = document.querySelector('.tl-cart-goal-apply-free-shipping-btn__cart-drawer');
      if (!btn) return;

      if (hasAppliedThisSession) {
        greyOutButton(btn);
        return;
      }

      if (isProcessing) return; // đang trong quá trình apply, chờ hoàn tất, tránh gọi thêm

      isProcessing = true;

      try {
        if (window.tlCartGoalEmbed && typeof window.tlCartGoalEmbed.handleApplyFreeShippingCode === 'function') {
          window.tlCartGoalEmbed.handleApplyFreeShippingCode();
        } else {
          btn.click();
        }
      } catch (_e) {}

      markAppliedPermanently();
      greyOutButton(btn);

      // Cho DOM/cart vài trăm ms để ổn định trước khi cho phép observer xử lý tiếp
      setTimeout(function () {
        isProcessing = false;
      }, 1500);
    }

    function debouncedCheck() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(autoApplyFreeShipping, 300);
    }

    var observer = new MutationObserver(function () {
      debouncedCheck();
    });

    function start() {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
        debouncedCheck();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

  } catch (globalErr) {
    console.warn('[Salepify Custom] Auto apply free shipping error:', globalErr);
  }
})();